import React from "react";
import type { SolutionFeedbackFieldProps } from "../../../../../../../../types/feedback/feedback";
import CustomSelect from "../../../../../../../common/custom-select";

const RoleField: React.FC<SolutionFeedbackFieldProps> = ({ formState, setFormState }) => (
  <div>
    <label className="block text-[16px] font-medium text-brand-textSubheading mb-[24px]">
      What best describes your role in relation to this problem?
    </label>
    <CustomSelect
      options={[
        { label: "I own this workflow / team", value: "owner" },
        { label: "I influence tools / process decisions", value: "influencer" },
        { label: "I'm a hands-on user, not the decision maker", value: "hands_on_user" },
        { label: "I'm just exploring / curious", value: "exploring" },
      ]}
      selectedValue={formState.roleRelation}
      onChange={(value) => setFormState((prev) => ({ ...prev, roleRelation: value }))}
      placeholder="Select your role..."
    />
  </div>
);

export default RoleField;
